import React, { Component, Fragment } from "react";
import { Row,
         Card,
		 Button} from "reactstrap";


//import axios from "axios";

//import { servicePath } from "../../constants/defaultValues";

import DataListView from "../../containers/customer/orders/DataListView";
import ImageListView from "../../containers/customer/orders/ImageListView";
import ThumbListView from "../../containers/customer/orders/ThumbListView";

import Pagination from "../../containers/pages/Pagination";
import ContextMenuContainer from "../../containers/pages/ContextMenuContainer";
import ListPageHeading from "../../containers/customer/orders/ListPageHeading";
import AddNewCustomerModal from "../../containers/customer/AddNewCustomerModal";


import { Colxx } from "../../components/common/CustomBootstrap";

import data from "../../data/updates";

function collect(props) {
  return { data: props.data };
}
//const apiUrl = servicePath + "/cakes/paging";

class Updates extends Component {
  constructor(props) {
    super(props);
    this.mouseTrap = require("mousetrap");

    this.state = {
      displayMode: "list",

      selectedPageSize: 10,
      orderOptions: [
        { column: "first_name", label: "First Name" },
        { column: "phone", label: "Phone" },
        { column: "email", label: "Email" }
      ],
      pageSizes: [10, 20, 30, 50, 100],

      selectedOrderOption: { column: "first_name", label: "First Name" },
      dropdownSplitOpen: false,
      modalOpen: false,
      currentPage: 1,
      totalItemCount: 0,
      totalPage: 1,
      search: "",
      selectedItems: [],
      lastChecked: null,
      isLoading: false
    };
  }
  componentDidMount() {
    this.dataListRender();
    this.mouseTrap.bind(["ctrl+a", "command+a"], () =>
      this.handleChangeSelectAll(false)
    );
    this.mouseTrap.bind(["ctrl+d", "command+d"], () => {
      this.setState({
        selectedItems: []
      });
      return false;
    });
  }

  componentWillUnmount() {
    this.mouseTrap.unbind("ctrl+a");
    this.mouseTrap.unbind("command+a");
    this.mouseTrap.unbind("ctrl+d");
    this.mouseTrap.unbind("command+d");
  }

  toggleModal = () => {
    this.setState({
      modalOpen: !this.state.modalOpen
    });
  };

  changeOrderBy = column => {
    this.setState(
      {
        selectedOrderOption: this.state.orderOptions.find(
          x => x.column === column
        )
      },
      () => this.dataListRender()
    );
  };
  changePageSize = size => {
    this.setState(
      {
        selectedPageSize: size,
        currentPage: 1
      },
      () => this.dataListRender()
    );
  };
  changeDisplayMode = mode => {
    this.setState({
      displayMode: mode
    });
    return false;
  };
  onChangePage = page => {
    this.setState(
      {
        currentPage: page
      },
      () => this.dataListRender()
    );
  };

  onSearchKey = e => {
    if (e.key === "Enter") {
      this.setState(
        {
          search: e.target.value.toLowerCase()
        },
        () => this.dataListRender()
      );
    }
  };

  onCheckItem = (event, id) => {
    if (
      event.target.tagName === "A" ||
      (event.target.parentElement && event.target.parentElement.tagName === "A")
    ) {
      return true;
    }
    if (this.state.lastChecked === null) {
      this.setState({
        lastChecked: id
      });
    }

    let selectedItems = this.state.selectedItems;
    if (selectedItems.includes(id)) {
      selectedItems = selectedItems.filter(x => x !== id);
    } else {
      selectedItems.push(id);
    }
    this.setState({
      selectedItems
    });

    if (event.shiftKey) {
      var items = this.state.items;
      var start = this.getIndex(id, items, "id");
      var end = this.getIndex(this.state.lastChecked, items, "id");
      items = items.slice(Math.min(start, end), Math.max(start, end) + 1);
      selectedItems.push(
        ...items.map(item => {
          return item.id;
        })
      );
      selectedItems = Array.from(new Set(selectedItems));
      this.setState({
        selectedItems
      });
    }
    document.activeElement.blur();
  };

  getIndex(value, arr, prop) {
    for (var i = 0; i < arr.length; i++) {
      if (arr[i][prop] === value) {
        return i;
      }
    }
    return -1;
  }
  handleChangeSelectAll = isToggle => {
    if (this.state.selectedItems.length >= this.state.items.length) {
      if (isToggle) {
        this.setState({
          selectedItems: []
        });
      }
    } else {
      this.setState({
        selectedItems: this.state.items.map(x => x.id)
      });
    }
    document.activeElement.blur();
    return false;
  };

  dataListRender() {
    /*const {
      selectedPageSize,
      currentPage,
      selectedOrderOption,
      search
    } = this.state;
    /*axios
      .get(
        `${apiUrl}?pageSize=${selectedPageSize}&currentPage=${currentPage}&orderBy=${
          selectedOrderOption.column
        }&search=${search}`
      )
      .then(res => {
        return res.data;
      })
      .then(data => {
        this.setState({
          totalPage: data.totalPage,
          items: data.data,
          selectedItems: [],
          totalItemCount: data.totalItem,
          isLoading: true
        });
      });*/
	  this.setState({
          totalPage: 2,
          items: data,
          selectedItems: [],
          totalItemCount: 20,
          isLoading: true
        });
  }

  onContextMenuClick = (e, data, target) => {
    console.log(
      "onContextMenuClick - selected items",
      this.state.selectedItems
    );
    console.log("onContextMenuClick - action : ", data.action);
  };

  onContextMenu = (e, data) => {
    const clickedProductId = data.data;
    if (!this.state.selectedItems.includes(clickedProductId)) {
      this.setState({
        selectedItems: [clickedProductId]
      });
    }

    return true;
  };

  render() {
    const {
      currentPage,
      items,
      displayMode,
      selectedPageSize,
      totalItemCount,
      selectedOrderOption,
      selectedItems,
      orderOptions,
      pageSizes,
      modalOpen
    } = this.state;
    const { match } = this.props;
    const startIndex = (currentPage - 1) * selectedPageSize;
    const endIndex = currentPage * selectedPageSize;

    return !this.state.isLoading ? (
      <div className="loading" />
    ) : (
      <Fragment>
        <div>
           <div >
		        <Row>
				    <div className=" mt-4 .req-left">
			 	      <img className="image-center"  alt="Responsive image" src="/assets/img/1.png" className="img-responsive" width="40" height="40"/>
                      </div>
			          <div className="mt-3 req-content req-item pl-2">
			               <p>Motagistics 9 months ago</p>
			               <p>Teammate Sreejish has been added to the request</p>
					</div>
			       
			   </Row>
		   </div>
		   <div>
			    <Row>
					    <div className="mt-4 req-left">
			 		        <img className="image-center"  alt="Responsive image" src="/assets/img/1.png" className="img-responsive" width="40" height="40"/>
                        </div>
					    <div className="mt-3 req-content req-item pl-2">
			               <p>Motagistics 9 months ago</p>
			               <p>Teammate Sreejish has been added to the request</p>
			            </div>
			    </Row>
		</div>	 
		</div>
		         <Row>
				       <Colxx lg="12">
		                 <div>
						 <Button color="success" >
                            Load More			            
						</Button>
			             </div>
					    </Colxx>
		         </Row>
		<div>
		    <Row>
			   <Colxx lg="12">
			       
			   </Colxx>
			</Row>
		</div>
      </Fragment>
    );
  }
}
export default Updates;
